// extracted by mini-css-extract-plugin
module.exports = {"card":"OrderContactInfo_card__yPzn-","cardTitle":"OrderContactInfo_cardTitle__2_O0a"};